{
  "contactModal": {
    "delete": {
      "cancel": "Cancelar",
      "confirm": "Excluir",
      "error": {
        "contactWithInformationRequests": "contactWithInformationRequests",
        "default": "default",
        "title": "title"
      },
      "message": "Tem certeza de que deseja excluir este contato?",
      "success": "success",
      "title": "Excluir contato"
    }
  },
  "contacts": {
    "buttons": {
      "add": "Adicionar um contato"
    },
    "table": {
      "headers": {
        "actions": "Ações",
        "email": "E-mail",
        "id": "ID",
        "name": "Nome"
      }
    }
  },
  "onboarding": {
    "actions": {
      "activateAccount": "Ativar conta",
      "back": "← Voltar",
      "next": "Seguinte"
    },
    "ariaLabel": "Passos de integração",
    "gate": {
      "retryBanner": {
        "message": "Ocorreu um erro. Por favor, atualize e tente novamente.",
        "retry": "Tentar novamente"
      }
    },
    "placeholder": "Conteúdo do passo em breve.",
    "stepIndicator": "Passo {{current}} de {{total}}",
    "steps": {
      "my_facilities": {
        "name": "Instalações",
        "subtitle": "Indique-nos quais instalações de produção utiliza e a respetiva empresa-mãe.",
        "title": "Adicione as suas instalações de produção"
      },
      "register_bp": {
        "name": "Parceiros comerciais",
        "subtitle": "Liste os contactos-chave das organizações parceiras — compradores, agentes ou subcontratados que devemos contactar para pedidos de rastreabilidade.",
        "title": "Adicione os seus parceiros comerciais"
      },
      "review": {
        "name": "Revisão",
        "subtitle": "Verifique se tudo está correto antes de ativar a sua conta.",
        "title": "Reveja os seus dados"
      },
      "verify_company": {
        "name": "Verificar empresa",
        "subtitle": "Confirme que temos a empresa correta antes de continuar.",
        "title": "Verifique o perfil da sua empresa"
      },
      "welcome": {
        "name": "Boas-vindas",
        "subtitle": "",
        "title": "Bem-vindo à Trace for Good"
      }
    },
    "verifyCompany": {
      "outcomes": {
        "answer_on_behalf": {
          "description": "For consultants, agents or partners filling in for the company shown above. Next, you'll register your company — responses stay attributed to you as their agent.",
          "label": "This is not my company, but I'm responding on their behalf"
        },
        "claim_company": {
          "description": "Confirm the profile above and continue setup as an employee of this company.",
          "label": "Yes, this is my company — I'd like to validate it"
        },
        "not_related": {
          "description": "Stops this verification. The person who invited you to Trace For Good will be notified so they can rectify the company shown above.",
          "label": "This isn't my company"
        }
      },
      "prompt": "Is this the profile of the company you are working at?",
      "summary": {
        "city": "City",
        "country": "Country",
        "street": "Street"
      }
    },
    "welcome": {
      "checkInfo": "Antes de aceder à sua conta Trace for Good, gostaríamos de confirmar algumas informações consigo.",
      "intro": "Estamos felizes por tê-lo connosco. Este portal foi concebido para facilitar a colaboração entre parceiros comerciais de várias cadeias de abastecimento no contexto da rastreabilidade de produtos e conformidade.",
      "invitation": "Foi convidado para a plataforma Trace for Good por <strong>{{invitingCompanyName}}</strong> para participar num processo de rastreabilidade de produtos. Este processo pode exigir que forneça informações sobre as cadeias de abastecimento."
    }
  },
  "productionSiteModal": {
    "actions": {
      "addRegistrationId": "Adicionar ID de registo",
      "backToProductionSite": "Voltar ao formulário do site",
      "cancel": "Cancelar",
      "delete": "Excluir",
      "removeRegistrationId": "Remover ID de registo",
      "save": "Guardar"
    },
    "createTitle": "Novo local de produção",
    "delete": {
      "cancel": "Cancelar",
      "confirm": "Excluir",
      "message": "Tem certeza de que deseja excluir este local de produção?",
      "title": "Excluir local de produção"
    },
    "editTitle": "Editar um local de produção",
    "errors": {
      "cityRequired": "A cidade é obrigatória",
      "coordinatesMaxDecimals": "Latitude e longitude podem ter no maximo 6 casas decimais",
      "countryMustBeValid": "País deve ser válido (ex. FR, DE)",
      "internalCodeTooLong": "O código interno deve ter menos de 32 caracteres",
      "nameRequired": "Nome é obrigatório",
      "parentCompanyRequired": "A empresa madre é obrigatória",
      "postalCodeTooShort": "O código postal deve ter pelo menos 3 caracteres",
      "streetRequired": "A rua é obrigatória",
      "streetTooShort": "A rua deve ter pelo menos 3 caracteres"
    },
    "labels": {
      "city": "Cidade do local de produção",
      "country": "País",
      "internalCode": "Código interno",
      "latitude": "Latitude do local de produção",
      "longitude": "Longitude do local de produção",
      "name": "Nome do local de produção",
      "parentCompany": "Empresa madre",
      "performedActivities": "Atividades realizadas",
      "postalCode": "Código postal do local de produção",
      "registrationId": "IDs de registo do site",
      "street": "Rua do local de produção"
    },
    "parentCompanyChange": {
      "cancel": "Manter a empresa madre atual",
      "confirm": "Alterar empresa madre",
      "message": "A empresa madre é a empresa a que este site pertence. Alterá-la atualizará a propriedade desta instalação e pode afetar o encaminhamento da rastreabilidade.",
      "title": "Alterar a empresa madre?"
    },
    "placeholders": {
      "city": "Cidade do local de produção",
      "country": "Selecione o país do site",
      "internalCode": "ex. BD-DAK-001 ou sua referência interna",
      "latitude": "Latitude do local de produção",
      "longitude": "Longitude do local de produção",
      "name": "ex. Unidade Corte e Costura Dhaka A",
      "parentCompany": "ex. Trace for Good",
      "performedActivities": "ex. Corte, costura, acabamento, tingimento",
      "postalCode": "Código postal do local de produção",
      "registrationId": "ex. NIF, CIN, GSTIN, USC",
      "street": "Rua do local de produção"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS: 9 dígitos.",
      "EORI": "EORI: código país + 14 dígitos.",
      "GLN": "GLN: 13 dígitos.",
      "OTHER": "Outro: máx. 32 caracteres.",
      "RCS": "RCS: RCS + espaço + nome empresa + espaço + [A,B] + espaço + 9 dígitos.",
      "VAT": "VAT: código país (ex. FR) + 2 dígitos + 9 dígitos SIREN."
    },
    "registrationIdErrors": {
      "DUNS": "O ID de registo DUNS deve ser um número de 9 dígitos.",
      "EORI": "O ID de registo EORI deve estar no formato: código país (ex. FR) + 14 dígitos.",
      "GLN": "O ID de registo GLN deve ser um número de 13 dígitos.",
      "OTHER": "O ID de registo outro deve ter menos de 32 caracteres.",
      "RCS": "O ID de registo RCS deve estar no formato: RCS + espaço + nome empresa + espaço + [A,B] + espaço + 9 dígitos.",
      "VAT": "O ID de registo VAT deve estar no formato: código país (ex. FR) + chave 2 dígitos + número SIREN 9 dígitos."
    },
    "tabs": {
      "generalInfo": "Informações gerais",
      "location": "Localização"
    },
    "tooltips": {
      "address": "Endereço do local de produção",
      "city": "Cidade do local de produção",
      "country": "País do local de produção",
      "internalCode": "Código interno do local de produção",
      "latitude": "Latitude do local de produção",
      "longitude": "Longitude do local de produção",
      "name": "Nome do local de produção",
      "parentCompany": "Empresa proprietária da instalação, selecionada na lista de parceiros comerciais registados.",
      "parentCompanyEdit": "Selecione a empresa proprietária deste site.",
      "parentCompanyReadOnly": "Apenas a organização que criou ou possui esta instalação pode alterar a empresa madre.",
      "performedActivities": "Atividades realizadas no local de produção",
      "postalCode": "Código postal do local de produção",
      "registrationId": "IDs de registo do local de produção",
      "street": "Rua do local de produção"
    }
  },
  "productionSites": {
    "buttons": {
      "add": "Adicionar um local de produção"
    },
    "create": {
      "error": "Erro ao criar o local de produção",
      "successCreated": {
        "message": "Local de produção criado com sucesso",
        "title": "Local de produção criado"
      },
      "successMerged": {
        "message": "Ja existe no seu repositorio um local de producao com este nome e endereco.",
        "title": "Local de producao existente encontrado"
      }
    },
    "delete": {
      "error": "Erro ao excluir o local de produção",
      "success": {
        "message": "Local de produção excluído com sucesso",
        "title": "Local de produção excluído"
      }
    },
    "filters": {
      "country": "País",
      "internalCode": "Código interno",
      "isConfidential": "Confidencial",
      "isConfidentialFalse": "Não",
      "isConfidentialTrue": "Sim",
      "name": "Nome do local de produção",
      "nothingFoundMessage": "nothingFoundMessage",
      "performedActivities": "Atividades realizadas no local de produção",
      "searchPlaceholder": "Buscar filtros",
      "title": "Filtros"
    },
    "search": {
      "placeholder": "Buscar por nome ou endereço"
    },
    "sorts": {
      "address": "Endereço",
      "country": "País",
      "email": "Email",
      "internalCode": "Código interno",
      "name": "Nome"
    },
    "table": {
      "headers": {
        "address": "Endereço",
        "certificates": "Certificados",
        "deleted": "Excluído",
        "id": "ID",
        "internalCode": "Código interno",
        "name": "Nome do local de produção",
        "parentCompany": "Empresa madre",
        "performedActivities": "Atividades realizadas",
        "registrationId": "IDs de registo do site"
      }
    },
    "title": "Locais de Produção",
    "update": {
      "error": "Erro ao atualizar o local de produção",
      "partialSave": {
        "message": "message"
      },
      "success": {
        "message": "Local de produção atualizado com sucesso",
        "title": "Local de produção atualizado"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "Erro"
    }
  }
}
